export const PREFERENCE_QUESTIONS = [
  {
    category: "About Your Stay",
    description: "What brings you to La Jolla?",
    questionKey: "brings_you_to_la_jolla",
    type: "single_select",
  },
  {
    category: "About Your Stay",
    description: "When do you expect to arrive?",
    questionKey: "arrival_time",
    type: "time",
  },
  {
    category: "About Your Stay",
    description: "Who will be joining you?",
    questionKey: "who_is_joining_you",
    type: "single_select",
  },
  {
    category: "Your Stay Style",
    description: "Which best describes the experience you're looking for?",
    questionKey: "experience_you_are_looking_for",
    type: "single_select",
  },
  {
    category: "Your Stay Style",
    description: "How would you describe your ideal level of interaction with our team?",
    questionKey: "interaction_with_team",
    type: "single_select",
  },
  {
    category: "Your Stay Style",
    description: "During your stay, how would you prefer housekeeping?",
    questionKey: "housekeeping_preference",
    type: "single_select",
  },
  {
    category: "Your Preferences",
    description: "How do you usually begin your mornings?",
    questionKey: "morning_routine",
    type: "single_select",
  },
  {
    category: "Your Preferences",
    description: "Which best reflects your travel style?",
    questionKey: "travel_style",
    type: "single_select",
  },
  {
    category: "Your Preferences",
    description: "Is there anything you'd like us to know before you arrive?",
    questionKey: "additional_information",
    type: "text",
  },
  {
    category: "Your Preferences",
    description:
      "If your best friend were bringing you a favorite snack or treat after a long day of travel, what would it be?",
    questionKey: "favorite_snack",
    type: "text",
  },
];
